<template>
	<!-- Create evaluation question -->
	<div class="container-evaluation-question">
		<ja-dropdown
			v-model="lifeInterestIndex"
			:disabled="!isEnable"
			:label="$t('lifeInterest')"
			:options="lifeEvents.interests"
			name="lifeInterest"
		></ja-dropdown>
		<ja-dropdown
			v-model="lifeEventTypeIndex"
			:disabled="!isEnable"
			:label="$t('lifeEventType')"
			:options="lifeEventTypeOptions"
			name="lifeEventType"
		></ja-dropdown>
		<span class="heading-5">{{ $t('lifeStage') }}</span>
		<div class="box-options">
			<div
				v-for="(option, index) in lifeEvents.lifeStages"
				:key="index"
				class="option"
			>
				<input
					v-model="option.isActive"
					type="checkbox"
					class="checkbox"
					:disabled="!isEnable"
					:name="option.name"
					@change="lifeStagesCheck(index)"
				/>
				<label class="heading-5" :for="option.name">
					{{ option.name }}
				</label>
			</div>
		</div>
		<ja-dropdown
			v-model="lifeActionIndex"
			:disabled="!isEnable"
			:label="$t('action')"
			:options="lifeActionOptions"
			name="action"
		></ja-dropdown>
		<span class="heading-5">{{ $t('account') }}</span>
		<div class="box-options">
			<div
				v-for="(option, index) in lifeEvents.accountTypes"
				:key="index"
				class="option"
			>
				<input
					v-model="option.isActive"
					:disabled="!isEnable"
					type="checkbox"
					class="checkbox"
					:name="option.name"
					@change="accountCheck(index)"
				/>
				<label class="heading-5" :for="option.name">
					{{ option.name }}
				</label>
			</div>
		</div>
		<ja-input
			v-model="lifeEvents.amount"
			:disabled="!isEnable"
			:label="$t('amount')"
			:name="$t('amount')"
			is-number-input
		></ja-input>
		<ja-textarea
			v-model="lifeEvents.description"
			:disabled="!isEnable"
			:max-length="300"
			:label="$t('lifeEventDescription')"
			:name="$t('lifeEventDescription')"
		></ja-textarea>
		<div class="container-buttons save">
			<ja-button
				v-if="isEnable"
				name="save"
				class="small outlined"
				:disabled="!isValid"
				@click.native="saveLifeEvent"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
			<ja-button
				v-if="isEnable"
				name="activated"
				class="small"
				@click.native="openModal()"
				>{{
					lifeEvents.isActive ? $t('deactivated') : $t('activated')
				}}</ja-button
			>
		</div>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="isActivated()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					lifeEvents.isActive
						? $t('deactivatedMessage')
						: $t('activatedMessage')
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import { choices, actions, ID_NEW_CMS } from '@/helpers/constants';
import { Dropdown, Input, Textarea } from '@/components/ui/form';
import AdminFacility from '@/mixins/AdminFacility';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import Button from '@/components/ui/Button';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaDropdown: Dropdown,
		jaTextarea: Textarea,
		jaButton: Button,
		jaInput: Input
	},
	mixins: [AdminFacility],
	props: {
		dataEdit: {
			type: Object,
			default: null,
			required: false
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			lifeEvents: null,
			lifeActionIndex: 0,
			lifeEventTypeIndex: 0,
			lifeInterestIndex: 0,
			selectedAll: false,
			lifeEventTypeOptions: choices,
			lifeActionOptions: actions
		};
	},
	computed: {
		isValid() {
			return (
				this.lifeEvents.interest_ID !== null &&
				this.lifeEvents.description !== null &&
				this.lifeEvents.amount !== null &&
				this.lifeEvents.selectedAccounts.length > 0 &&
				this.lifeEvents.selectedLifeStages.length > 0
			);
		},
		isEnable() {
			return (
				(this.isSuperAdmin || this.isUSAAdmin) && this.selectedFacilityId == 0
			);
		}
	},
	watch: {
		lifeInterestIndex(newIndex) {
			this.lifeEvents.interest_ID = this.lifeEvents.interests[
				newIndex
			].interest_ID;
		},
		lifeEventTypeIndex(newIndex) {
			this.lifeEvents.mustChooseAccount = this.lifeEventTypeOptions[
				newIndex
			].value;
		},
		lifeActionIndex(newIndex) {
			this.lifeEvents.isAmountAdded = this.lifeActionOptions[newIndex].value;
		}
	},
	created() {
		this.lifeEvents = this.dataEdit;
		this.setInitialIndexes();
	},
	methods: {
		setInitialIndexes() {
			if (this.lifeEvents.lifeEvent_ID === ID_NEW_CMS) {
				this.lifeEvents.selectedAccounts = [];
				this.lifeEvents.selectedLifeStages = [];
				this.lifeEvents.isAmountAdded = false;
				this.lifeEvents.interest_ID = this.lifeEvents.interests[
					this.lifeInterestIndex
				].interest_ID;
			}
			this.lifeEvents.accountTypes.forEach(accountType => {
				if (
					this.lifeEvents.selectedAccounts.includes(accountType.accountType_ID)
				) {
					accountType.isActive = true;
				}
			});

			this.lifeEvents.lifeStages.forEach(lifeStage => {
				if (
					this.lifeEvents.selectedLifeStages.includes(lifeStage.lifeStage_ID)
				) {
					lifeStage.isActive = true;
				} else {
					lifeStage.isActive = false;
				}
			});

			this.lifeActionIndex =
				this.lifeActionOptions.findIndex(
					action => action.value === this.lifeEvents.isAmountAdded
				) !== -1
					? this.lifeActionOptions.findIndex(
							action => action.value === this.lifeEvents.isAmountAdded
					  )
					: 0;

			this.lifeEventTypeIndex =
				this.lifeEventTypeOptions.findIndex(
					choice => choice.value === this.lifeEvents.mustChooseAccount
				) !== -1
					? this.lifeEventTypeOptions.findIndex(
							choice => choice.value === this.lifeEvents.mustChooseAccount
					  )
					: 0;

			this.lifeInterestIndex =
				this.lifeEvents.interests.findIndex(
					interest => interest.interest_ID === this.lifeEvents.interest_ID
				) !== -1
					? this.lifeEvents.interests.findIndex(
							interest => interest.interest_ID === this.lifeEvents.interest_ID
					  )
					: 0;
		},
		accountIsSelected(option) {
			const isSelected = this.lifeEvents.selectedAccounts.includes(
				option.accountTypeID
			);
			return isSelected;
		},
		accountCheck(index) {
			const isActive = this.lifeEvents.accountTypes[index].isActive;
			const accountTypeID = this.lifeEvents.accountTypes[index].accountType_ID;
			const isSelected = this.lifeEvents.selectedAccounts.includes(
				accountTypeID
			);

			if (isActive && !isSelected) {
				this.lifeEvents.selectedAccounts.push(accountTypeID);
			} else if (!isActive && isSelected) {
				const selectedIndex = this.lifeEvents.selectedAccounts.indexOf(
					accountTypeID
				);
				this.lifeEvents.selectedAccounts.splice(selectedIndex, 1);
			}
		},
		lifeStagesCheck(index) {
			const lifeStageID = this.lifeEvents.lifeStages[index].lifeStage_ID;
			const isSelected = this.lifeEvents.selectedLifeStages.includes(
				lifeStageID
			);

			if (!isSelected) {
				this.lifeEvents.selectedLifeStages.push(lifeStageID);
			} else if (isSelected) {
				const selectedIndex = this.lifeEvents.selectedLifeStages.indexOf(
					lifeStageID
				);
				this.lifeEvents.selectedLifeStages.splice(selectedIndex, 1);
			}
		},
		saveLifeEvent() {
			this.lifeEvents.isActive = true;
			this.$emit('saveLifeEvent', this.lifeEvents);
		},
		openModal() {
			this.showMessageDeletionModal = true;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		},
		isActivated() {
			this.lifeEvents.isActive = !this.lifeEvents.isActive;
			this.$emit('saveLifeEvent', this.lifeEvents);
			this.showMessageDeletionModal = false;
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-evaluation-question {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
.questions {
	justify-content: flex-start;
}
.save {
	justify-content: flex-end;
}
.box-options {
	border: 1px solid $button-border;
	display: flex;
	gap: 30px;
	padding: 15px;
}
.option {
	display: flex;
	gap: 10px;
	margin: 5px;
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.text-label {
	margin: 10px 0 10px 0;
}
</style>
